import React, { ReactElement } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type Props = {
    boxLogisticInformation: string;
    shopName?: string;
};

const BoxPromise = ({
    shopName,
    boxLogisticInformation,
}: Props): ReactElement => {
    const { t } = useGranite();
    return (
        <div className="mb-2">
            {shopName && (
                <div className="small font-weight-bold">
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            {!shopName && (
                <div className="small">
                    {t("general.ecommerce.clickAndCollect.noStore")}
                </div>
            )}
            <div className="small">
                <span className="">
                    <i className="las la-check mr-1"></i>
                    {boxLogisticInformation}
                </span>
            </div>
        </div>
    );
};

export default BoxPromise;
